import { QueryClient } from '@tanstack/react-query';
import { cacheKey, FEATURE_FLAG_NAMES } from '@tn/foundation/entities/feature-flags/constants';
import { getFeatureFlag } from '@tn/foundation/entities/feature-flags/utils/getFeatureFlag';

export const shouldUseIdentityService = (queryClient: QueryClient): boolean => {
    const featureFlags =
        queryClient.getQueryData<{ featureFlags?: Record<string, unknown> }>([cacheKey])
            ?.featureFlags ?? {};

    return Boolean(
        getFeatureFlag(featureFlags)(FEATURE_FLAG_NAMES.UNIFIED_IDENTITY_PLATFORM, false),
    );
};
